export type Typography = typeof typography;

export const typography = {
    fontFamily: 'sofia-pro, sans-serif',
    fontWeightRegular: 400,
    fontWeightBold: 700
};
